export default __webpack_public_path__ + "static/media/student-online-application-logo.5fff002b.svg";